import api from './api'
export const getWorkerCredentialSummary = async (profileId: string, tenantId: string, signal: AbortSignal): Promise<unknown> =>
  (await api.get(`/api/worker-profiles/${encodeURIComponent(profileId)}`, { signal, headers: { 'x-tenant-id': tenantId } })).data
